// Mock data for NEX Gym

export const gymInfo = {
  name: "NEX",
  tagline: "Transforma tu cuerpo, transforma tu vida",
  description: "NEX es más que un gimnasio, es tu centro de transformación física y mental. Con equipamiento de última generación, entrenadores personales certificados y nutrióloga especializada.",
  phone: "+51 939 573 726",
  email: "info@nexgym.com",
  address: "Simón Salguero 560, Santiago de Surco 15039",
  hours: {
    weekdays: "Lunes - Viernes: 6:00 - 23:00",
    saturday: "Sábado: 8:00 - 21:00",
    sunday: "Domingo: 9:00 - 20:00"
  }
};

export const memberships = [
  {
    id: 1,
    name: "1 Mes",
    price: "250",
    period: "mes",
    features: [
      "Acceso ilimitado al gimnasio",
      "Equipamiento de última generación",
      "Vestuarios y duchas",
      "Asesoramiento inicial"
    ],
    popular: false
  },
  {
    id: 2,
    name: "2 Meses + 7 Días",
    price: "400",
    period: "total",
    features: [
      "Todo lo de 1 Mes",
      "7 días adicionales gratis",
      "Seguimiento personalizado",
      "Plan de entrenamiento básico"
    ],
    popular: true
  },
  {
    id: 3,
    name: "3 Meses + 10 Días",
    price: "550",
    period: "total",
    features: [
      "Todo lo anterior",
      "10 días adicionales gratis",
      "Evaluación física mensual",
      "Consulta con nutrióloga",
      "Mayor ahorro"
    ],
    popular: false
  },
  {
    id: 4,
    name: "6 Meses + 20 Días",
    price: "900",
    period: "total",
    features: [
      "Todo lo anterior",
      "20 días adicionales gratis",
      "Plan nutricional personalizado",
      "Seguimiento continuo",
      "Máximo ahorro"
    ],
    popular: false
  }
];

export const trainers = [
  {
    id: 1,
    name: "Rodrigo Valle de Paz",
    specialty: "Musculación y Competencias",
    role: "Director y Entrenador Principal",
    experience: "20 años",
    age: "37 años",
    photo: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/d5nt9qw6_image.png",
    certifications: ["IFBB Pro", "Campeón Mr. Olympia Amateur 2017"],
    bio: "Coach fitness él junto a su gran equipo van a ayudarte a crear tu mejor versión.",
    personality: "Dedicado, motivador, profesional"
  },
  {
    id: 2,
    name: "¡Tu puedes ser el proximo!",
    specialty: "Buscamos talento y experiencia",
    role: "Coach en Nex Level Fitness",
    experience: "-",
    age: "-",
    photo: "https://cdn.oreateai.com/agentskill/64b9751ca4cc924cc403afc4/multimedia/9025cc0d1f48d0da0ffb97c5.png",
    certifications: ["Pasión por el fitness"],
    bio: "¿Eres un apasionado del entrenamiento? Únete a nuestro equipo y ayuda a otros a alcanzar su mejor versión.",
    personality: "Motivador, Proactivo"
  },
  {
    id: 3,
    name: "Yandel Cayo",
    specialty: "Preparación de Competencias",
    role: "Entrenador de Alto Rendimiento",
    experience: "7 años",
    age: "24 años",
    photo: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/0c0l9uz6_WhatsApp%20Image%202026-07-07%20at%206.15.09%20PM.jpeg",
    certifications: ["Competidor Activo", "Entrenamiento de Alto Rendimiento"],
    bio: "Yandel, entrenador exigente y comprometido con sacar el máximo potencial de cada alumno. Su enfoque está orientado a llevar a sus clientes al siguiente nivel, combinando disciplina, técnica y un seguimiento constante.Además de su experiencia en el entrenamiento, participó en la competencia Mister Huaral, fortaleciendo su conocimiento práctico del alto rendimiento. Cuenta con certificación en Nutrición y formación en MAS FITNES.",
    personality: "Motivador, competitivo, profesional"
  },
  {
    id: 4,
    name: "Antony Medrano Altamirano",
    specialty: "Entrenamiento de Alta Intensidad",
    role: "Entrenador Personal",
    experience: "4 años",
    age: "32 años",
    photo: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/djrnreq6_image.png",
    certifications: ["Entrenamiento de Alta Intensidad", "Motivación Deportiva"],
    bio: "Antony es un entrenador apasionado por el desarrollo físico y el progreso constante de sus alumnos. Destaca por su amplio conocimiento en la planificación de rutinas completas y personalizadas, adaptando cada entrenamiento a las necesidades y objetivos de cada persona para maximizar sus resultados. Su estilo de entrenamiento combina exigencia, disciplina y un acompañamiento cercano, motivando a sus alumnos a superar sus propios límites y alcanzar su máximo potencial. Además, se caracteriza por ser un entrenador atento, comprometido y constante.",
    personality: "Motivador, exigente, energético"
  },
  {
    id: 5,
    name: "Sabrina Lazeres",
    specialty: "Tonificación y Asesoramiento",
    role: "Entrenadora Personal",
    experience: "4 años",
    age: "26 años",
    photo: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/jjgas542_image.png",
    certifications: ["Especialista en Tonificación", "Asesoramiento Fitness"],
    bio: "Sabrina, entrenadora con amplia experiencia en el mundo del fitness y el entrenamiento personalizado. Su trayectoria incluye la participación en competencias de fisicoculturismo, experiencia que le ha permitido desarrollar un profundo conocimiento sobre la preparación física, la disciplina y el logro de objetivos. Además, cuenta con conocimientos en nutrición y brinda asesoría personalizada, complementando cada plan de entrenamiento con recomendaciones adaptadas a las necesidades y metas de cada persona. Su compromiso, constancia y seguimiento cercano hacen que cada alumno reciba el apoyo necesario para transformar su estilo de vida y alcanzar su máximo potencial.",
    personality: "Amigable, motivadora, exelente para principiantes"
  },
  {
    id: 6,
    name: "Valeria Tintaya Quispe",
    specialty: "Cardio Intensivo",
    role: "Entrenadora Personal",
    experience: "4 años",
    age: "25 años",
    photo: "https://customer-assets.emergentagent.com/job_nex-fitness/artifacts/5w7jxv6u_image.png",
    certifications: ["Especialista en Cardio", "Entrenamiento al Fallo"],
    bio: "Se caracteriza por su paciencia, dedicación y acompañamiento constante, creando un ambiente de confianza para que sus alumnos alcancen sus objetivos.Cuenta con varios años de experiencia en el entrenamiento físico y destaca por su constancia y disciplina, cualidades que la llevaron a ser ganadora en competencias de la categoría Bikini.",
    personality: "amable, paciente, motivadora"
  }
];

export const schedule = [
  {
    id: 1,
    day: "Lunes",
    classes: [
      { time: "07:00", name: "Yoga Matutino", trainer: "Laura Sánchez", duration: "60 min" },
      { time: "10:00", name: "CrossFit", trainer: "Carlos Martínez", duration: "45 min" },
      { time: "18:00", name: "HIIT", trainer: "Miguel Ruiz", duration: "45 min" },
      { time: "19:30", name: "Pilates", trainer: "Laura Sánchez", duration: "60 min" }
    ]
  },
  {
    id: 2,
    day: "Martes",
    classes: [
      { time: "08:00", name: "Spinning", trainer: "Miguel Ruiz", duration: "45 min" },
      { time: "12:00", name: "Yoga Flow", trainer: "Laura Sánchez", duration: "60 min" },
      { time: "18:30", name: "Entrenamiento Funcional", trainer: "Carlos Martínez", duration: "60 min" },
      { time: "20:00", name: "Zumba", trainer: "Ana Torres", duration: "45 min" }
    ]
  },
  {
    id: 3,
    day: "Miércoles",
    classes: [
      { time: "07:00", name: "Yoga Matutino", trainer: "Laura Sánchez", duration: "60 min" },
      { time: "10:00", name: "CrossFit", trainer: "Carlos Martínez", duration: "45 min" },
      { time: "18:00", name: "HIIT", trainer: "Miguel Ruiz", duration: "45 min" },
      { time: "19:30", name: "Pilates", trainer: "Laura Sánchez", duration: "60 min" }
    ]
  },
  {
    id: 4,
    day: "Jueves",
    classes: [
      { time: "08:00", name: "Spinning", trainer: "Miguel Ruiz", duration: "45 min" },
      { time: "12:00", name: "Yoga Flow", trainer: "Laura Sánchez", duration: "60 min" },
      { time: "18:30", name: "Entrenamiento Funcional", trainer: "Carlos Martínez", duration: "60 min" },
      { time: "20:00", name: "Body Pump", trainer: "Carlos Martínez", duration: "45 min" }
    ]
  },
  {
    id: 5,
    day: "Viernes",
    classes: [
      { time: "07:00", name: "Yoga Matutino", trainer: "Laura Sánchez", duration: "60 min" },
      { time: "10:00", name: "CrossFit", trainer: "Carlos Martínez", duration: "45 min" },
      { time: "18:00", name: "HIIT", trainer: "Miguel Ruiz", duration: "45 min" },
      { time: "19:30", name: "Zumba", trainer: "Ana Torres", duration: "45 min" }
    ]
  },
  {
    id: 6,
    day: "Sábado",
    classes: [
      { time: "09:00", name: "Yoga Suave", trainer: "Laura Sánchez", duration: "60 min" },
      { time: "11:00", name: "CrossFit", trainer: "Carlos Martínez", duration: "45 min" },
      { time: "17:00", name: "Spinning", trainer: "Miguel Ruiz", duration: "45 min" }
    ]
  },
  {
    id: 7,
    day: "Domingo",
    classes: [
      { time: "10:00", name: "Yoga Restaurativo", trainer: "Laura Sánchez", duration: "75 min" },
      { time: "12:00", name: "Entrenamiento Funcional", trainer: "Miguel Ruiz", duration: "60 min" }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    role: "Miembro desde 2022",
    rating: 5,
    text: "NEX ha cambiado mi vida completamente. Los entrenadores son increíbles y las instalaciones están siempre impecables. He perdido 15kg y me siento más fuerte que nunca.",
    avatar: "MG"
  },
  {
    id: 2,
    name: "Javier Rodríguez",
    role: "Miembro desde 2021",
    rating: 5,
    text: "El mejor gimnasio en el que he estado. El ambiente es motivador y los entrenadores realmente se preocupan por tu progreso.",
    avatar: "JR"
  },
  {
    id: 3,
    name: "Carmen López",
    role: "Miembro desde 2023",
    rating: 5,
    text: "Los dias de pierna con Laura son increíbles. He mejorado mi flexibilidad y reducido mi estrés significativamente. El plan nutricional también ha sido clave en mi transformación.",
    avatar: "CL"
  },
  {
    id: 4,
    name: "David Fernández",
    role: "Miembro desde 2020",
    rating: 5,
    text: "Llevo 4 años en NEX y no cambiaría por nada. La variedad de clases, el equipamiento y sobre todo el equipo humano hacen que cada día quiera volver.",
    avatar: "DF"
  },
  {
    id: 5,
    name: "Isabel Moreno",
    role: "Miembro desde 2023",
    rating: 5,
    text: "Después de probar varios gimnasios, finalmente encontré mi lugar en NEX. Las instalaciones son de primer nivel y el trato personalizado marca la diferencia.",
    avatar: "IM"
  },
  {
    id: 6,
    name: "Pedro Jiménez",
    role: "Miembro desde 2022",
    rating: 5,
    text: "Soy una persona de 56 años, y al principio dude de entrar al gimnasio pero al ver que el personal era muy amigable y profesional decidi insicribrme por tres meses, fue la mejor desicion de mi larga vida ahora puedo cargar a mis nietos y hacer cosas que no podia hacer.",
    avatar: "PJ"
  }
];
